import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Key, Plus } from 'lucide-react'
import api from '../../services/api'

const STATUS_BADGE: Record<string, string> = {
  draft: 'badge-medium', pending_approval: 'badge-high', approved: 'badge-low',
  active: 'badge-low', suspended: 'badge-high', cancelled: 'badge-medium', closed: 'badge-medium'
}

const PERMIT_ICONS: Record<string, string> = {
  hot_work: '🔥', confined_space: '🕳️', electrical_isolation: '⚡',
  heights: '🏗️', excavation: '⛏️', general: '📋'
}

export default function PermitsList() {
  const [permits, setPermits] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState('')

  useEffect(() => {
    api.get(`/permits${status ? `?status=${status}` : ''}`)
      .then(r => { setPermits(r.data.data); setTotal(r.data.total) })
      .finally(() => setLoading(false))
  }, [status])

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>Permits to Work</h1>
          <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>{total} total</p>
        </div>
        <Link to="/permits/new" className="btn btn-primary">
          <Plus size={16} /> New Permit
        </Link>
      </div>

      <div className="card p-4 flex gap-3 flex-wrap">
        {[
          { val: '', label: 'All' },
          { val: 'active', label: 'Active' },
          { val: 'pending_approval', label: 'Pending Approval' },
          { val: 'draft', label: 'Draft' },
          { val: 'closed', label: 'Closed' },
        ].map(({ val, label }) => (
          <button key={val} onClick={() => setStatus(val)}
            className={`btn ${status === val ? 'btn-primary' : 'btn-secondary'} text-xs py-1`}>
            {label}
          </button>
        ))}
      </div>

      {loading ? <div className="text-center py-12" style={{ color: 'var(--text-muted)' }}>Loading...</div> :
        permits.length === 0 ? (
          <div className="card text-center py-16">
            <Key size={40} className="mx-auto mb-3" style={{ color: 'var(--text-muted)' }} />
            <p style={{ color: 'var(--text-muted)' }}>No permits found</p>
          </div>
        ) : (
          <div className="space-y-2">
            {permits.map(p => (
              <Link key={p.id} to={`/permits/${p.id}`} className="card flex items-center gap-4 hover:shadow-md transition-all block">
                <span className="text-2xl">{PERMIT_ICONS[p.permit_type] || '📋'}</span>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-sm" style={{ color: 'var(--text)' }}>{p.permit_number}</p>
                  <p className="text-xs mt-0.5 truncate" style={{ color: 'var(--text-muted)' }}>{p.work_description}</p>
                  <p className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                    {p.site_name || 'No site'} · Valid: {new Date(p.valid_from).toLocaleDateString('en-AU')} → {new Date(p.valid_to).toLocaleDateString('en-AU')}
                  </p>
                </div>
                <span className={`badge ${STATUS_BADGE[p.status] || ''} capitalize flex-shrink-0`}>{p.status?.replace('_', ' ')}</span>
              </Link>
            ))}
          </div>
        )
      }
    </div>
  )
}
